import React from 'react';
import { Box, Button, CircularProgress, DialogTitle, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Can from '../../../components/permissions/Can';

export default function TaskDetailsHeader({
  taskTitle,
  statusText,
  loading,
  refreshing,
  saving,
  onRefresh,
  onClose,
  onSave,
}) {
  return (
    <DialogTitle sx={{ pb: 1.5, borderBottom: '1px solid', borderColor: 'divider', bgcolor: '#f7fafc' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {taskTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {statusText}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            onClick={onRefresh}
            variant="outlined"
            size="small"
            disabled={loading || refreshing}
            startIcon={refreshing ? <CircularProgress size={14} color="inherit" /> : <RefreshIcon />}
          >
            Refresh
          </Button>
          <Button onClick={onClose} variant="outlined" size="small">
            Close
          </Button>
          <Can permission="task-edit">
            <Button onClick={onSave} variant="contained" size="small" disabled={loading || saving}>
              {saving ? <CircularProgress size={18} color="inherit" /> : 'Save changes'}
            </Button>
          </Can>
        </Box>
      </Box>
    </DialogTitle>
  );
}
